export default "__VITE_ASSET__CYdvv584__"